import { inject, Injectable } from '@angular/core';
import { ApiClient } from '../api-client.service';
import type {
  ShippingDocumentsCreateRequest,
  ShippingDocumentsCreateResponse,
  ShippingDocumentStatusRequest,
  ShippingDocumentStatusResponse,
} from './models/shipping-documents.model';

/**
 * Thin client for the existing shipping-documents-service create and status operations.
 */
@Injectable({ providedIn: 'root' })
export class ShippingDocumentsApiService {
  private readonly apiClient = inject(ApiClient);

  /**
   * Starts asynchronous shipping-document generation.
   */
  create(request: ShippingDocumentsCreateRequest): Promise<ShippingDocumentsCreateResponse> {
    return this.apiClient.post<ShippingDocumentsCreateResponse>(
      '/shipping-documents/create',
      request,
    );
  }

  /**
   * Retrieves the current state of one generated shipping document.
   */
  status(request: ShippingDocumentStatusRequest): Promise<ShippingDocumentStatusResponse> {
    return this.apiClient.post<ShippingDocumentStatusResponse>(
      '/shipping-documents/status',
      request,
    );
  }
}
